import React from 'react'
import prefetchCmsPage from 'graphql/prefetchers/prefetchCmsPage'
import { initializeApollo } from 'lib/apolloClient'
import { isServer } from 'lib/utils'
import { NextPageContext } from 'next'

import EnrollPage from 'components/EnrollPage/EnrollPage'
import PublicLayout from 'components/PublicLayout/PublicLayout'

function Enroll(): JSX.Element {
  return (
    <PublicLayout>
      <EnrollPage />
    </PublicLayout>
  )
}

Enroll.getInitialProps = async (ctx: NextPageContext) => {
  if (isServer()) {
    const apolloClient = initializeApollo(ctx)
    await prefetchCmsPage(apolloClient, { slug: 'enroll' })

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }

  return {}
}

export default Enroll
